import {JSX} from "react";

import SmartImage from "@/shared/ui/smart-image";

import {Typography} from "@/shared/ui/data-display/typography/typography";

import "./amenity.scss";

interface AmenityProps {
    icon: string;
    alt: string;
    value?: string | number;
    plus?: boolean;
    text: string;
    className?: string;
}

export function Amenity({icon, alt, value, plus = false, text, className = ""}: AmenityProps): JSX.Element {
    // Handle NaN/undefined values
    const displayValue = value == null || (typeof value === "number" && isNaN(value)) ? "" : value;

    return (
        <div className={`amenity ${className}`}>
            <SmartImage src={icon} alt={alt} width={16} height={16} className="amenity__icon" />
            <Typography as="div" size={{desktop: 12, mobile: 10}} weight={400} color="paragraph2" className="amenity__text">
                {displayValue !== "" && <span className="amenity__number">{displayValue}</span>}
                {plus && displayValue !== "" && <span className="amenity__plus">+</span>}
                <span className="amenity__name">{text}</span>
            </Typography>
        </div>
    );
}
